import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { routes } from 'routes/routes'
import { useAppDispatch } from 'store/hooks'
import { openFaq } from 'store/slice/learn-library.slice'

export function useFaq() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const handleClickFaq = useCallback(() => {
    dispatch(openFaq({ faqReturnUrl: location.pathname }))
    navigate(routes.learnLibrary)
  }, [dispatch, navigate, location])

  return {
    onOpenFaq: handleClickFaq,
  }
}
